import React from 'react';

import { useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';

import { Element, ElementFill, Svg } from '~/assets/icons/styles';

const ClockIcon = ({ color, secondaryColor, boldHand = true, ...rest }) => {
  const theme = useTheme();
  const svgColor = color || alpha(theme.palette.common.white, 0.15);
  secondaryColor = secondaryColor || alpha(theme.palette.common.white, 0.15);
  return (
    <Svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      {...rest}
      svgColor={svgColor}
    >
      <Element as="circle" cx="31.99999" cy="32.00001" r="27" fill="#ffffff" />
      <ElementFill
        d="M31.172,34A4.00129,4.00129,0,0,1,30,31.172V16a2,2,0,1,1,4,0V31.172l7.414,7.414a1.9997,1.9997,0,1,1-2.828,2.828C36.598,39.428,33.018,35.846,31.172,34Z"
        secondaryColor={secondaryColor}
      />
      {boldHand && (
        <Element d="M31.172,34A4.00129,4.00129,0,0,1,30,31.172V16a2,2,0,1,1,4,0V31.172l7.414,7.414a1.9997,1.9997,0,1,1-2.828,2.828C36.598,39.428,33.018,35.846,31.172,34Z" />
      )}
    </Svg>
  );
};

export default ClockIcon;
